function getStringFromNumberString(value)
{
  let num=parseInt(value.replace(/[^0-9]/g,''))
  let str=value.replace(num,'')
  return num!==undefined&& !Number.isNaN(num)?`${str.toUpperCase()}`:value
}

export default getStringFromNumberString